import { Col, Form, Row, Select, Switch, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { instanceRef } from '../../utils/axios';

const { Option } = Select;

const ConstruccionForm = ({ construccionData, setConstruccionData, form }) => {
  const [pisosOptions, setPisosOptions] = useState([]);
  const [paredesOptions, setParedesOptions] = useState([]);
  const [techoOptions, setTechoOptions] = useState([]);
  const [cielorrasoOptions, setCielorrasoOptions] = useState([]);
  const [entrepisosOptions, setEntrepisosOptions] = useState([]);
  const [tieneCielorraso, setTieneCielorraso] = useState(true);
  const [tieneEntrepiso, setTieneEntrepiso] = useState(true);

  const cantidadNiveles = [
    { value: 1, descripcion: '1' },
    { value: 2, descripcion: '2' },
    { value: 3, descripcion: '3' },
    { value: 4, descripcion: '4' },
    { value: 5, descripcion: '5' },
    { value: 6, descripcion: '6' },
    { value: 7, descripcion: '7' },
    { value: 8, descripcion: '8' },
    { value: 9, descripcion: '9' },
    { value: 10, descripcion: '10' },
    { value: 11, descripcion: '11' },
    { value: 12, descripcion: '12' },
    { value: 13, descripcion: '13' },
    { value: 14, descripcion: '14' },
    { value: 15, descripcion: '15' },
    { value: 0, descripcion: '+ niveles' }
  ];

  // Función para cambiar los datos del estado construccionData
  const handleFormChange = (value, field) => {
    const idSelectedList = value;
    // Se define el nombre del campo modificado
    let construccionOptions = [];
    if (field === 'pisos') {
      construccionOptions = pisosOptions;
    } else if (field === 'paredes') {
      construccionOptions = paredesOptions;
    } else if (field === 'cielorrasos') {
      construccionOptions = cielorrasoOptions;
    } else if (field === 'entrepisos') {
      construccionOptions = entrepisosOptions;
    } else if (field === 'techos') {
      construccionOptions = techoOptions;
    }
    // Se filtran los objetos seleccionados
    const detalleObjList = construccionOptions.filter((item) =>
      idSelectedList.includes(item.id)
    );
    if (
      field !== 'cantidadNiveles' &&
      field !== 'tieneCielorraso' &&
      field !== 'tieneEntrepiso'
    ) {
      setConstruccionData({ ...construccionData, [field]: detalleObjList });
    } else {
      setConstruccionData({ ...construccionData, [field]: value });
    }
  };

  // Función para buscas  y construir la lista de todos los campos del sector de construccion.
  const fetchAllConstruccionOptions = async () => {
    try {
      const response = await instanceRef.instance.get('/construccion');
      const construccionOpcionesList = response.data.data;
      if (construccionOpcionesList.length > 0) {
        const pisosTipo = construccionOpcionesList.find(
          (tipo) => tipo.codigo === '1'
        );
        const paredesTipo = construccionOpcionesList.find(
          (tipo) => tipo.codigo === '2'
        );
        const techosTipo = construccionOpcionesList.find(
          (tipo) => tipo.codigo === '3'
        );
        const cielorrasoTipo = construccionOpcionesList.find(
          (tipo) => tipo.codigo === '4'
        );

        const entrepisosTipo = construccionOpcionesList.find(
          (tipo) => tipo.codigo === '5'
        );

        setPisosOptions(pisosTipo.detalle);
        setParedesOptions(paredesTipo.detalle);
        setTechoOptions(techosTipo.detalle);
        setCielorrasoOptions(cielorrasoTipo.detalle);
        setEntrepisosOptions(entrepisosTipo.detalle);
      }
      return null;
    } catch (e) {
      message.error(e.message);
      return null;
    }
  };

  // Función para obtener los IDs de una lista de objetos
  const obtenerIds = (lista) => {
    return lista.map((objeto) => objeto.id) || [];
  };

  // Función para mostrar u ocultar selector con opciones de cielorrasos
  const handleSwitchCielorraso = (checked) => {
    if (!checked) {
      // NO tiene, por debajo se selecciona la opcion "No posee" que se encuentra oculta en su lista de cielorrasos
      const opcionNoPosee = cielorrasoOptions.filter((item) =>
        item.descripcion.includes('No posee')
      );
      form.setFieldValue('cielorrasos', opcionNoPosee);
      setConstruccionData({ ...construccionData, cielorrasos: opcionNoPosee });
    } else {
      // SI tiene, muestra selector
      form.setFieldValue('cielorrasos', []);
      setConstruccionData({ ...construccionData, cielorrasos: [] });
    }
    setTieneCielorraso(checked);
  };

  // Función para mostrar u ocultar selector con opciones de entrepisos
  const handleSwitchEntrepiso = (checked) => {
    if (!checked) {
      // NO tiene, por debajo se selecciona la opcion "No posee" que se encuentra oculta en su lista de entrepisos

      const opcionNoPosee = entrepisosOptions.filter((item) =>
        item.descripcion.includes('No posee')
      );
      setConstruccionData({ ...construccionData, entrepisos: opcionNoPosee });
    } else {
      // SI tiene, muestra selector

      setConstruccionData({ ...construccionData, entrepisos: [] });
    }
    setTieneEntrepiso(checked);
  };

  useEffect(() => {
    if (pisosOptions.length === 0) {
      fetchAllConstruccionOptions();
    }
  }, [pisosOptions]);

  useEffect(() => {
    // Mantener los valores del formulario con los datos del estado ConstruccionData
    if (construccionData) {
      const idConstruccionlist = [];
      for (const key in construccionData) {
        if (Array.isArray(construccionData[key])) {
          idConstruccionlist[key] = obtenerIds(construccionData[key]);
        }
      }

      form.setFieldsValue({
        ...idConstruccionlist,
        cantidadNiveles: construccionData.cantidadNiveles,
        tieneCielorraso: construccionData.tieneCielorraso,
        tieneEntrepiso: construccionData.tieneEntrepiso
      });

      setTieneCielorraso(construccionData.tieneCielorraso);
      setTieneEntrepiso(construccionData.tieneEntrepiso);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  useEffect(() => {
    setConstruccionData((prevData) => ({
      ...prevData,
      tieneCielorraso,
      tieneEntrepiso
    }));
  }, [tieneCielorraso, tieneEntrepiso, setConstruccionData]);

  return (
    <Form
      name="construccionForm"
      form={form}
      layout="vertical"
      autoComplete="off"
    >
      <Row gutter={[16, 0]} style={{ maxWidth: '1200px', margin: 'auto' }}>
        <Col xs={24} md={12} align="start">
          <Form.Item
            label="Tipo de Pisos"
            name="pisos"
            rules={[{ required: true }]}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Elegir pisos"
              onChange={(value) => {
                handleFormChange(value, 'pisos');
              }}
            >
              {pisosOptions.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} align="start">
          <Form.Item
            label="Tipo de Paredes"
            name="paredes"
            rules={[{ required: true }]}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Elegir paredes"
              onChange={(value) => {
                handleFormChange(value, 'paredes');
              }}
            >
              {paredesOptions.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12} align="start">
          <Form.Item
            label="Tipo de Techos"
            name="techos"
            rules={[{ required: true }]}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Elegir techos"
              onChange={(value) => {
                handleFormChange(value, 'techos');
              }}
            >
              {techoOptions.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12} align="start">
          <Form.Item
            label="Cantidad de niveles"
            name="cantidadNiveles"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Elegir cantidad de niveles"
              onChange={(value) => {
                handleFormChange(value, 'cantidadNiveles');
              }}
            >
              {cantidadNiveles.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} align="start">
          <Form.Item
            label="¿Posee Cielorraso?"
            name="tieneCielorraso"
            // rules={[{ required: true }]}
            valuePropName="checked"
          >
            <Switch
              checkedChildren="Si"
              unCheckedChildren="No"
              defaultChecked
              checked={tieneCielorraso}
              onChange={handleSwitchCielorraso}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} align="start">
          {tieneCielorraso && (
            <Form.Item
              label="Tipo de cielorrasos"
              name="cielorrasos"
              rules={[{ required: true }]}
            >
              <Select
                mode="multiple"
                style={{ width: '100%' }}
                placeholder="Elegir cielorrasos"
                onChange={(value) => {
                  handleFormChange(value, 'cielorrasos');
                }}
              >
                {cielorrasoOptions.map((item) => (
                  <Option
                    key={item.id}
                    value={item.id}
                    hidden={item.descripcion.includes('No posee')} // o el codigo?
                  >
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
        </Col>
        <Col xs={24} md={12} align="start">
          <Form.Item
            label="¿Posee Entrepiso?"
            name="tieneEntrepiso"
            valuePropName="checked"
          >
            <Switch
              checkedChildren="Si"
              unCheckedChildren="No"
              defaultChecked
              checked={tieneEntrepiso}
              onChange={handleSwitchEntrepiso}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} align="start">
          {tieneEntrepiso && (
            <Form.Item
              label="Tipo de Entrepisos"
              name="entrepisos"
              rules={[{ required: true }]}
            >
              <Select
                mode="multiple"
                style={{ width: '100%' }}
                placeholder="Elegir entrepisos"
                onChange={(value) => {
                  handleFormChange(value, 'entrepisos');
                }}
              >
                {entrepisosOptions.map((item) => (
                  <Option
                    key={item.id}
                    value={item.id}
                    hidden={item.descripcion.includes('No posee')}
                  >
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
        </Col>
      </Row>
    </Form>
  );
};

export default ConstruccionForm;
